import { render } from "./ReportDisplayField.vue?vue&type=template&id=471da748&scoped=true"
import script from "./ReportDisplayField.vue?vue&type=script&lang=js"
export * from "./ReportDisplayField.vue?vue&type=script&lang=js"

import "./ReportDisplayField.vue?vue&type=style&index=0&id=471da748&lang=scss&scoped=true"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471da748"]])

export default __exports__